import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import React from 'react';

import { Flex, Text } from '~/components/blocks';
import {
  DirectVisitorOnAllPatientListFragment,
  LineVisitorOnAllPatientListFragment,
  PatientOnAllPatientListFragment,
  WebVisitorOnAllPatientListFragment,
} from '~/graphql/generated/graphql';
import { toHHMM, toYYYYMMDDja } from '~/utils/date';

type Props = {
  patient:
    | WebVisitorOnAllPatientListFragment
    | DirectVisitorOnAllPatientListFragment
    | LineVisitorOnAllPatientListFragment
    | PatientOnAllPatientListFragment;
};

const EllipsisText = styled(Text)(() =>
  css({
    maxWidth: '496px',
    // 50文字に対し6割の30文字まで表示、以下「…」
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
);

export const CommentColumn = ({ patient }: Props) => {
  const medixsPatientComment = patient.medixsPatient?.medicationFollowupComments.nodes[0];
  const latestComment = medixsPatientComment || patient.medicationFollowupComments.nodes[0];

  if (!latestComment) return null;

  return (
    <Flex>
      <EllipsisText>{latestComment.comment}</EllipsisText>
      {`（${toYYYYMMDDja(latestComment.updatedAt)} ${toHHMM(latestComment.updatedAt)}）`}
    </Flex>
  );
};
